import { postReq, putReq } from '../infra/http';
import { getReq, createUrl } from "@/infra/http";
import { PagedResponseModel, BaseResponseModel, PaginatedSelectModel } from "@/models/core.model";
import { RunEvent, runEventFromJson, RunEventList, RunEventPaginationFilterRequest, RunEventType, UpsertRunEvent } from '@/models/run-event.model';

export const getPagedRunEvents = async (input: RunEventPaginationFilterRequest): Promise<PagedResponseModel<RunEventList>> => {
  return await getReq(createUrl("a/RunEvent/PagedData"),
    { params: input }
  ).then((res: any) => ({
      ...res.data,
      result: res.data.result.map(itm => runEventFromJson<RunEventList>(itm))
    }));
};

export const getRunEventsLookup = async (input?: string, page?: number, type?: RunEventType): Promise<PaginatedSelectModel> => {
  const model: RunEventPaginationFilterRequest = {
    pageNumber: page ?? 1,
    pageSize: 100,
    keyword: input,
    isAscending: false,
    type: type
  };
  return await getPagedRunEvents(model).then(data => 
    ({ 
      data: data.result.map(itm => ({ 
        value: itm.id, 
        label: itm.name
      })),
      isLastPage: data.pageNumber >= data.totalPages,
    })         
  );
};

export const getRunEvent = async (id: number): Promise<BaseResponseModel<RunEvent>> => {
  return await getReq(createUrl(`a/RunEvent/GetById/${id}`),
  ).then((res: any) => ({
      ...res.data,
      result: runEventFromJson<RunEvent>(res.data.result)
    }));
};

export const submitRunEvent = async (input: UpsertRunEvent): Promise<BaseResponseModel<RunEvent>> => {
  return await postReq(createUrl("a/RunEvent/Submit"),
    input
  ).then((res: any) => ({
      ...res.data,
      result: runEventFromJson<RunEvent>(res.data.result)
    }));
};

export const updateRunEvent = async (input: UpsertRunEvent): Promise<BaseResponseModel<null>> => {
  return await putReq(createUrl("a/RunEvent/Update"),
    input
  ).then((res: any) => res.data);
};